import React from 'react';
import { cn } from './_cn';
import {
  OrderStatus,
  PaymentStatus,
  PlatformTypes,
  CouponStatus,
} from '../../data/enums';

const toneClass = {
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  violet:
    'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300',
  purple:
    'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  rose: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
  emerald:
    'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  sky: 'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300',
  slate: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
};

const sizes = {
  sm: 'px-2 py-0.5 text-[0.65rem]',
  md: 'px-3 py-1 text-xs',
  lg: 'px-4 py-1.5 text-sm',
};

export const orderStatusMap = {
  0: { tone: 'amber', label: OrderStatus[0] },
  10: { tone: 'blue', label: OrderStatus[10] },
  20: { tone: 'purple', label: OrderStatus[20] },
  30: { tone: 'slate', label: OrderStatus[30] },
  40: { tone: 'rose', label: OrderStatus[40] },
  100: { tone: 'emerald', label: OrderStatus[100] },
};

export const paymentStatusMap = {
  0: { tone: 'rose', label: PaymentStatus[0] },
  20: { tone: 'emerald', label: PaymentStatus[20] },
};

export const platformStatusMap = {
  0: { tone: 'slate', label: PlatformTypes[0] },
  10: { tone: 'purple', label: PlatformTypes[10] },
  20: { tone: 'blue', label: PlatformTypes[20] },
};

export const couponStatusMap = {
  0: { tone: 'slate', label: CouponStatus[0] },
  1: { tone: 'blue', label: CouponStatus[1] },
  2: { tone: 'emerald', label: CouponStatus[2] },
  3: { tone: 'amber', label: CouponStatus[3] },
  4: { tone: 'rose', label: CouponStatus[4] },
  5: { tone: 'slate', label: CouponStatus[5] },
};

const StatusBadge = ({
  status,
  map,
  tone,
  label,
  size = 'md',
  className = '',
  dot = false,
}) => {
  const entry = map && status in map ? map[status] : null;
  const resolvedTone = tone || entry?.tone || 'slate';
  const resolvedLabel = label ?? entry?.label ?? '—';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-semibold',
        toneClass[resolvedTone] || toneClass.slate,
        sizes[size] || sizes.md,
        className,
      )}
    >
      {dot ? (
        <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden />
      ) : null}
      {resolvedLabel}
    </span>
  );
};

export const OrderStatusBadge = (props) => (
  <StatusBadge map={orderStatusMap} {...props} />
);

export const PaymentStatusBadge = (props) => (
  <StatusBadge map={paymentStatusMap} {...props} />
);

export const PlatformBadge = (props) => (
  <StatusBadge map={platformStatusMap} {...props} />
);

export const CouponStatusBadge = (props) => (
  <StatusBadge map={couponStatusMap} {...props} />
);

export default StatusBadge;
